import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import initEventsFilter from './filter';

const loader = new Loader({
    apiKey: 'AIzaSyAxYcC10bTXoApNU0BMInur6NY_YHkGUFc',
    version: 'weekly',
});

const initMap = (mapEl) => {
    const canvas = mapEl.querySelector('.js-map-canvas');
    const { mapLat } = mapEl.dataset;
    const { mapLng } = mapEl.dataset;

    const markers = mapEl.querySelectorAll('.js-marker');
    const content = mapEl.querySelector('.js-map-content');

    const eventList = document.querySelector('.js-event-listing');
    const cards = eventList.querySelectorAll('.js-event-card');

    let bounds;

    const latLng = {
        lat: parseFloat(mapLat),
        lng: parseFloat(mapLng)
    };

    const mapArgs = {
        zoom: 12,
        center: latLng,
        backgroundColor: '#c9eb94',
        disableDefaultUI: true,
        mapId: 'cc814f174db11922cbc6efa8',
    };

    const buildIcon = (marker) => { 
        const iconContent = document.createElement('div');
        iconContent.classList.add('marker-icon');

        const markerTitle = marker.dataset.title;

        iconContent.innerHTML = `<svg width="19" height="23" viewBox="0 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="pin-bg" d="M9.51953 19.4805L8.64648 20.375L9.51953 21.2266L10.3916 20.375L9.51953 19.4805ZM9.51953 19.4805L10.3926 20.374L10.3984 20.3682C10.4022 20.3644 10.4082 20.3593 10.415 20.3525C10.4288 20.339 10.4483 20.3191 10.4736 20.2939C10.5242 20.2436 10.5973 20.1707 10.6895 20.0771C10.8741 19.8897 11.1365 19.6191 11.4502 19.2842C12.0762 18.6158 12.9138 17.6828 13.7549 16.6299C14.5924 15.5815 15.455 14.3878 16.1133 13.2002C16.7522 12.0475 17.288 10.7454 17.2881 9.51953C17.2881 5.22888 13.8101 1.75021 9.51953 1.75C5.22875 1.75 1.75 5.22875 1.75 9.51953C1.75011 10.7455 2.28682 12.0474 2.92578 13.2002C3.58407 14.3878 4.44572 15.5815 5.2832 16.6299C6.12429 17.6827 6.96191 18.6158 7.58789 19.2842C7.90155 19.6191 8.16397 19.8897 8.34863 20.0771C8.44077 20.1707 8.51384 20.2436 8.56445 20.2939C8.58971 20.3191 8.60933 20.339 8.62305 20.3525C8.62991 20.3593 8.63584 20.3644 8.63965 20.3682L8.64551 20.374L9.51953 19.4805Z" fill="#FF59B7" stroke="#FF59B7" stroke-width="2.5"/><path class="pin-inner" d="M9.51953 3.75C12.7056 3.75021 15.2881 6.33345 15.2881 9.51953C15.288 10.224 14.9576 11.1583 14.3633 12.2305C13.7804 13.2821 12.9937 14.3787 12.1924 15.3818C11.3934 16.382 10.5924 17.274 9.99023 17.917C9.81521 18.1039 9.65438 18.2666 9.51855 18.4072C9.38286 18.2668 9.22263 18.1036 9.04785 17.917C8.44566 17.274 7.64467 16.382 6.8457 15.3818C6.04436 14.3787 5.2577 13.2821 4.6748 12.2305C4.08053 11.1583 3.75012 10.2239 3.75 9.51953C3.75 6.33332 6.33332 3.75 9.51953 3.75Z" stroke="white" stroke-width="1.5"/><circle class="pin-dot" cx="9.52063" cy="8.77649" r="1.53625" fill="white"/></svg><span class="marker-icon__title">${markerTitle}</span>`;

        return iconContent;
    };

    const toggleHighlight = (marker, otherMarkers, map) => {
        // Untoggle other markers
        otherMarkers.forEach((other) => {
            if (other !== marker) {
                other.content.classList.remove('active');
                other.zIndex = 0;
            }
        });

        // Activate clicked marker
        if (!marker.content.classList.contains('active')) {
            marker.content.classList.add('active');
            marker.zIndex = 1;
            map.panTo(marker.position);
        } else {
            marker.content.classList.remove('active');
            marker.zIndex = 0;
        }
    };

    loader.load().then(async () => {
        const { google } = window;
        const { Map } = await google.maps.importLibrary('maps');
        const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
        bounds = new google.maps.LatLngBounds();

        const eventsMap = new Map(canvas, mapArgs);

        window.eventsMap = eventsMap;
        window.eventMarkers = [];
        const markerLatLngs = [];

        const markerArray = [...markers].map((marker, i) => {
            let markerLat = parseFloat(marker.dataset.lat);
            let markerLng = parseFloat(marker.dataset.lng);
            let latLngCheck = `${markerLat},${markerLng}`;

            if (markerLatLngs.includes(latLngCheck)) {
                // Get offset value between -0.00001 and 0.00001
                const getRandomValue = () => (Math.random() * 0.00006) - 0.00003;

                // Slightly offset marker longitude
                markerLat -= i * getRandomValue();
                markerLng -= i * getRandomValue();

                // Reset check values
                latLngCheck = `${markerLat},${markerLng}`;
            }

            // Update latLng check array
            markerLatLngs.push(latLngCheck);

            const markerLatLng = new google.maps.LatLng(markerLat, markerLng);

            bounds.extend(markerLatLng);

            const markerEl = new AdvancedMarkerElement({
                position: markerLatLng,
                content: buildIcon(marker)
            });

            markerEl.id = marker.dataset.id;

            window.eventMarkers.push(markerEl);
            window.activeEventMarker = null;

            markerEl.addListener('click', () => {
                toggleHighlight(markerEl, window.eventMarkers, eventsMap);

                cards.forEach((card) => {
                    // Toggle content
                    if (marker.dataset.id === card.dataset.id) {
                        // If marker already active hide it
                        if (marker.dataset.id === window.activeEventMarker) {
                            window.activeEventMarker = null;
                            content.classList.remove('active');

                            // Delay for animation
                            setTimeout(() => {
                                content.innerHTML = '';
                            }, 300);
                        } else {
                            window.activeEventMarker = marker.dataset.id;
                            content.innerHTML = '';
                            const cloneCard = card.cloneNode(true);
                            content.appendChild(cloneCard);

                            const closeBtn = document.createElement('button');

                            closeBtn.classList.add('event-card-close', 'button', 'button--small', 'button--white');
                            closeBtn.innerHTML = '<span class="visually-hidden">Close card</span><svg class="svg-fill svg-close" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.795356 2.2049L2.20957 0.790691L19.2091 17.7903L17.7949 19.2045L0.795356 2.2049Z"/><path d="M17.7808 0.77961L19.195 2.19382L2.19546 19.1934L0.78125 17.7792L17.7808 0.77961Z"/></svg>';

                            closeBtn.addEventListener('click', () => {
                                window.activeEventMarker = null;
                                content.classList.remove('active');

                                // Remove highlight from active marker
                                markerEl.content.classList.remove('active');
                                markerEl.zIndex = 0;

                                // Delay for animation
                                setTimeout(() => {
                                    content.innerHTML = '';
                                }, 300);
                            });

                            content.appendChild(closeBtn);

                            content.classList.add('active');
                        }
                    }
                });
            });

            return markerEl;
        });

        if (window.eventMarkers.length === 1) {
            eventsMap.setCenter(bounds.getCenter());
            eventsMap.setZoom(15);
        } else {
            eventsMap.fitBounds(bounds);
            eventsMap.panToBounds(bounds);
        }

        const eventsFilter = document.querySelector('.js-event-filter');

        // Init filters
        if (eventsFilter) {
            initEventsFilter(eventsFilter);
        }

        // Zoom buttons
        const zoomIn = mapEl.querySelector('.js-map-zoom-in');
        const zoomOut = mapEl.querySelector('.js-map-zoom-out');

        zoomIn.addEventListener('click', () => {
            const currentZoom = eventsMap.getZoom();

            if (currentZoom !== 21) {
                eventsMap.setZoom(currentZoom + 1);
            }
        });

        zoomOut.addEventListener('click', () => {
            const currentZoom = eventsMap.getZoom();

            if (currentZoom !== 10) {
                eventsMap.setZoom(currentZoom - 1);
            }
        });

        const markerCluster = new MarkerClusterer({
            markers: markerArray,
            gridOptions: {
                gridSize: 30
            },
            algorithmOptions: {
                maxZoom: 19
            },
            renderer: {
                render: ({ count, position }, stats, map) => {
                    // change color if this cluster has more markers than the mean cluster
                    const color = '#ff59b7';

                    // create svg url with fill color
                    const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
                                    <circle cx="120" cy="120" opacity="1" r="80" stroke="#fff" stroke-width="10" />
                                    <text x="50%" y="50%" style="fill:#fff" font-weight="bold" text-anchor="middle" font-size="65" 
                                    dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
                                </svg>`;

                    const parser = new DOMParser();
                    const svgEl = parser.parseFromString(svg, 'image/svg+xml').documentElement;
                    svgEl.setAttribute('transform', 'translate(0 25)');

                    const title = `Cluster of ${count} markers`;
                    const zIndex = 1000 + count;

                    const clusterMarkerOptions = {
                        map,
                        position,
                        zIndex,
                        title,
                        content: svgEl
                    };

                    return new AdvancedMarkerElement(clusterMarkerOptions);
                }
            },
            onClusterClick: (event, cluster, map) => {
                const clusterBounds = new google.maps.LatLngBounds();
                cluster.markers.forEach((marker) => {
                    clusterBounds.extend(marker.position);
                });

                map.fitBounds(clusterBounds);

                // Clamp zoom
                const listener = map.addListener('idle', () => {
                    const maxZoom = 19;
                    if (map.getZoom() > maxZoom) {
                        map.setZoom(maxZoom);
                    }
                    google.maps.event.removeListener(listener);
                });
            },
        });

        window.markerCluster = markerCluster;
        window.markerCluster.setMap(window.eventsMap);
    });
};

export { initMap as default };
